import styled from 'styled-components';
import { CentralDialog, colours } from '@cambridgeassessment/cambridge-ui';

export const StyledCentralDialog = styled(CentralDialog)`
  & .MuiDialog-paper {
    overflow-y: visible;
    min-width: 200px;
    width: 100%;
    max-width: 505px;
  }
  & .MuiDialogContentText-root {
    color: ${colours.black};
  }
`;
